import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://172.30.1.92:3000';

const API_CONFIG = {
    // 서버 설정
    servers: {
        internal: 'http://172.30.1.92:80',
        external: 'http://14.33.192.19:80',
        local: 'http://localhost:80',
        prod: 'https://twsyggspze.execute-api.ap-northeast-2.amazonaws.com/prod'
    },
    
    // 기본 설정
    default: {
        timeout: 10000,
        headers: {
            'Content-Type': 'application/json',
        }
    },
    
    // 연결 테스트 설정
    health: {
        endpoint: '/health',
        timeout: 3000
    }
};

const getApiUrl = () => {
    // 환경 변수로 직접 설정된 경우
    // if (process.env.REACT_APP_API_URL) {
    //     return process.env.REACT_APP_API_URL;
    // }
    
    // // 개발 환경에서는 로컬 서버 사용
    // if (process.env.NODE_ENV === 'development') {
    //     return API_CONFIG.servers.local;
    // }
    
    // 프로덕션 환경에서는 IP 기반 결정
    // return getApiUrlByIp();

    const hostname = window.location.hostname;
    
    // 내부망 IP 범위 확인
    const isInternalNetwork = () => {
        const ipParts = hostname.split('.').map(Number);
        
        // 172.16.0.0 ~ 172.31.255.255
        if (ipParts[0] === 172 && ipParts[1] >= 16 && ipParts[1] <= 31) {
            return true;
        }
        
        // 192.168.0.0 ~ 192.168.255.255
        if (ipParts[0] === 192 && ipParts[1] === 168) {
            return true;
        }
        
        // 10.0.0.0 ~ 10.255.255.255
        if (ipParts[0] === 10) {
            return true;
        }
        
        return false;
    };

    const isExternalNetwork = () => {
        const ipParts = hostname.split('.').map(Number);
        
        if (ipParts[0] === 14 && ipParts[1] == 33 && ipParts[2] == 192) {
            return true;
        }
        
        return false;
    };

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return API_CONFIG.servers.local;
    }
    
    if (isInternalNetwork()) {
        return API_CONFIG.servers.internal;
    }

    if (isExternalNetwork()) {
        return API_CONFIG.servers.external;
    }

    return API_CONFIG.servers.prod;
};

const s3Api = {
    // 허용된 파일 타입 조회
    getAllowedFileTypes: async () => {
        try {
            const response = await axios.get(`${getApiUrl()}/s3/allowed-types`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            console.error('허용된 파일 타입 조회 에러:', error);
            throw new Error(error.response?.data?.message || '파일 타입 정보를 불러오는데 실패했습니다.');
        }
    },

    // 파일 존재 여부 확인
    checkFileExists: async (fileName) => {
        try {
            const response = await axios.get(`${getApiUrl()}/s3/check-exists`, {
                params: { fileName },
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            console.error('파일 존재 확인 에러:', error);
            throw new Error(error.response?.data?.message || '파일 존재 여부를 확인하는데 실패했습니다.');
        }
    },

    // 단일 파일 업로드 URL 생성
    generateUploadUrl: async (fileName, fileType) => {
        try {
            const response = await axios.post(`${getApiUrl()}/s3/upload-url`, {
                fileName,
                fileType
            }, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            console.error('업로드 URL 생성 에러:', error);
            throw new Error(error.response?.data?.message || '업로드 URL을 생성하는데 실패했습니다.');
        }
    },

    // 단일 파일 다운로드 URL 생성
    generateDownloadUrl: async (fileName) => {
        try {
            const response = await axios.post(`${getApiUrl()}/s3/download-url`, {
                fileName
            }, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            console.error('다운로드 URL 생성 에러:', error);
            throw new Error(error.response?.data?.message || '다운로드 URL을 생성하는데 실패했습니다.');
        }
    },

    // 여러 파일 업로드 URL 생성
    generateMultipleUploadUrls: async (files) => {
        try {
            const response = await axios.post(`${getApiUrl()}/s3/multiple-upload-urls`, {
                files
            }, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            console.error('다중 업로드 URL 생성 에러:', error);
            throw new Error(error.response?.data?.message || '업로드 URL들을 생성하는데 실패했습니다.');
        }
    },

    // 파일 삭제
    deleteFile: async (fileName) => {
        try {
            const response = await axios.delete(`${getApiUrl()}/s3/delete`, {
                params: { fileName },
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            console.error('파일 삭제 에러:', error);
            throw new Error(error.response?.data?.message || '파일 삭제에 실패했습니다.');
        }
    }
};

export default s3Api; 